import useFetchObjects from "../../api/useFetchObjects";

const usePopularAuthors = () => {
  const {
    data: authors,
    loading,
    error,
    refetch,
  } = useFetchObjects(["popular-authors"], "popular-authors/");

  return {
    authors,
    loading,
    error,
    refetch,
  };
};

export default usePopularAuthors;
